import { OzTag, TAG_COLORS, TAG_SIZES, TAG_VARIANTS } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

export interface ISweepstakesTagProps {
    hasWinner: boolean;
    closeDate: Date;
}

const MAX_DAYS: number = 7;
const MILLISECONDS_PER_HOUR: number = 1000 * 60 * 60;

function getHoursFromNow (closeDate: Date): number {
    const milliseconds: number = closeDate.getTime() - Date.now();

    return Math.ceil(milliseconds / MILLISECONDS_PER_HOUR);
}

function getDaysFromNow (closeDate: Date): number {
    return Math.ceil(getHoursFromNow(closeDate) / 24);
}

export function SweepstakesTag (props: ISweepstakesTagProps): ReactElement | null {
    const {
        hasWinner,
        closeDate,
    }: ISweepstakesTagProps = props;

    const hours: number = getHoursFromNow(closeDate);
    const days: number = getDaysFromNow(closeDate);
    let tagColor: TAG_COLORS = TAG_COLORS.VIOLET;
    let tagText: string = 'Winner Pending';

    if (days > MAX_DAYS) {
        return null;
    }

    if (days > 2) {
        tagColor = TAG_COLORS.YELLOW;
        tagText = `${days} days left!`;
    } else if (hours === 1) {
        tagColor = TAG_COLORS.YELLOW;
        tagText = `${hours} hour left!`;
    } else if (hours > 1) {
        tagColor = TAG_COLORS.YELLOW;
        tagText = `${hours} hours left!`;
    } else if (hasWinner) {
        tagColor = TAG_COLORS.WHITE;
        tagText = 'See who won!';
    }

    return (
        <OzTag color={tagColor} size={TAG_SIZES.SMALL} variant={TAG_VARIANTS.SQUARE}>
            {tagText}
        </OzTag>
    );
}
